<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ clientIcon }}</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Serial No</label>
                    <md-input
                      v-model="form.serialNo"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Invoice Name</label>
                    <md-input
                      v-model="form.invoicingName"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Stat. Insp. Frequency</label>
                    <md-select v-model="form.statInspFrequency" required>
                      <md-option :value="6">6 months</md-option>
                      <md-option :value="12">12 months</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label class="font-weight-bold">Plant Type</label>
                    <md-select v-model="form.plantTypeId" required>
                      <md-option
                        v-for="plant in plantTypeOptions"
                        :key="plant.id"
                        :value="plant.id"
                        >{{ plant.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Location</label>
                    <md-input
                      v-model="form.location"
                      type="text"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Detail</label>
                    <md-textarea
                      v-model="form.detail"
                      md-autogrow
                    ></md-textarea>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <h4>Contractor</h4>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Contractor</label>
                    <md-select
                      v-model="contractorRegion.contractorId"
                      @md-selected="onContractorSelected"
                      required
                    >
                      <md-option
                        v-for="contractor in contractorOptions"
                        :key="contractor.id"
                        :value="contractor.id"
                        >{{ contractor.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Region</label>
                    <md-select v-model="form.contractorRegionId" required>
                      <md-option
                        v-for="region in contractorRegionOptions"
                        :key="region.id"
                        :value="region.id"
                        >{{ region.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
              ><md-icon class="material-icons">check</md-icon>Submit</md-button
            >
            <md-button class="md-danger md-sm" @click="onCancel"
              ><md-icon class="material-icons">close</md-icon>Cancel</md-button
            >
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      hasSubmit: false,
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      clientIcon: "data-management-client/icon",
      plantTypeOptions: "data-management-client/plantTypes",
      contractorOptions: "data-management-contractor/contractors",
      contractorRegionOptions: "data-management-contractor/regions",
      contractorRegion: "data-management-contractor/region",
      form: "data-management-client/plant"
    })
  },
  created() {
    this.$store.dispatch("data-management-client/getPlantTypes");
    this.$store.dispatch("data-management-contractor/getContractorListing");
    this.$store
      .dispatch("data-management-client/getPlant", this.$route.params.plantId)
      .then(() => {
        this.$store
          .dispatch(
            "data-management-contractor/getContractorRegionDetails",
            this.form.contractorRegionId
          )
          .then(() => {
            this.$store.dispatch(
              "data-management-contractor/getContractorRegionListing",
              this.contractorRegion.contractorId
            );
          });
      });
  },
  methods: {
    onContractorSelected(evt) {
      this.$store.dispatch(
        "data-management-contractor/getContractorRegionListing",
        evt
      );
      if (this.loaded) {
        this.form.contractorRegionId = undefined;
      } else {
        this.loaded = true;
      }
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("data-management-client/editPlant", this.form)
        .then(() => {
          this.$router.push({ name: "Plant" });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
